import React from 'react'
import Navbar from '../../components/Navbar'
import Sidebar from '../../components/Sidebar'
import TemperatureFaultComponent from '../../components/TemperatureFaultComponent/TemperatureFaultComponent'

const TemperatureFault = () => {
    return (
        <div>
            <div className='flex'>
                <div className='w-[15%]'>
                    <Sidebar />
                </div>
                <div>
                    <Navbar />
                    <TemperatureFaultComponent/>
                </div>
            </div>
        </div>
    )
}

export default TemperatureFault
